import type { PortableTextMarkComponentProps } from '@portabletext/react';
import type { TypedObject } from '@portabletext/types';
import type { ReactNode } from 'react';
import { alignClass, type TextAlign } from '../utils/alignClass';

export type AlignValue = TypedObject & {
    _type: 'align';
    value?: TextAlign;
};

export function AlignWrapper({ value, children }: { value?: AlignValue; children: ReactNode }) {
    const a = value?.value ?? 'left';
    return <span className={`block w-full ${alignClass(a)}`}>{children}</span>;
}

export const alignMark = ({ value, children }: PortableTextMarkComponentProps<AlignValue>) => {
    return <AlignWrapper value={value}>{children}</AlignWrapper>;
};
